/* Alma theme: small, dependency-free behaviours. */
(function () {
  "use strict";
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* header: shadow when stuck, mobile menu */
  const hdr = $(".hdr");
  if (hdr) {
    const stuck = () => hdr.classList.toggle("is-stuck", window.scrollY > 8);
    stuck(); addEventListener("scroll", stuck, { passive: true });
    const burger = $(".hdr__burger", hdr);
    if (burger) burger.onclick = () => { const open = hdr.classList.toggle("is-open"); burger.setAttribute("aria-expanded", open); };
  }

  /* scroll reveal */
  const els = $$(".reveal");
  if ("IntersectionObserver" in window && els.length) {
    const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }), { rootMargin: "0px 0px -8% 0px" });
    els.forEach((el) => io.observe(el));
  } else els.forEach((el) => el.classList.add("in"));
  const stage = $("[data-open-on-view]");
  if (stage) {
    if ("IntersectionObserver" in window) {
      const o = new IntersectionObserver((en) => en.forEach((e) => { if (e.isIntersecting) { stage.classList.add("open"); o.disconnect(); } }), { threshold: 0.55 });
      o.observe(stage);
    } else stage.classList.add("open");
  }

  /* product page */
  const form = $("#product-form");
  if (form) {
    const data = JSON.parse($("#product-json").textContent);
    const money = (c) => (c / 100).toLocaleString("es-MX", { style: "currency", currency: data.currency }).replace(/\s?MXN$/, "");
    const priceEl = $("#price"), idEl = $("#variant-id"), mainImg = $("#main-img"), btn = $("#add-btn");
    const optionInputs = $$("[data-option]", form);
    const groups = [...new Set(optionInputs.map((i) => i.name))];
    const selected = () => {
      // Product with a single version (no options): use its only variant.
      if (!groups.length) return data.variants.find((v) => String(v.id) === idEl.value) || data.variants[0] || null;
      const picked = groups.map((n) => { const c = optionInputs.find((i) => i.name === n && i.checked); return c ? c.value : null; });
      return data.variants.find((v) => v.options.every((o, i) => o === picked[i])) || null;
    };
    const sync = () => {
      const v = selected();
      if (!v) { btn.disabled = true; btn.textContent = "No disponible"; return; }
      idEl.value = v.id;
      priceEl.textContent = money(v.price);
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.label : "Agotado";
      if (v.image && mainImg) { mainImg.src = v.image; $$(".prod__thumbs button").forEach((b) => b.setAttribute("aria-pressed", b.dataset.src === v.image)); }
    };
    $$("[data-option]", form).forEach((i) => i.addEventListener("change", sync));
    sync();
    $$(".prod__thumbs button").forEach((b) => (b.onclick = () => { mainImg.src = b.dataset.src; $$(".prod__thumbs button").forEach((x) => x.setAttribute("aria-pressed", x === b)); }));

    /* engraving: live preview on the locket drawing */
    const eng = $("#engrave"), engPrev = $("#engrave-prev"), count = $("#engrave-count");
    if (eng) {
      const max = Number(eng.maxLength) || 20;
      const upd = () => { const v = eng.value.trim(); engPrev.textContent = v || eng.dataset.placeholder; engPrev.style.opacity = v ? 1 : 0.45; count.textContent = `${eng.value.length}/${max}`; };
      eng.addEventListener("input", upd); upd();
    }

    /* locket photo: preview inside the locket, validate size */
    const photo = $("#photo"), drop = $("#drop"), photoPrev = $("#photo-prev"), photoName = $("#photo-name"), photoErr = $("#photo-err");
    if (photo) {
      photo.addEventListener("change", () => {
        const f = photo.files[0]; photoErr.textContent = "";
        if (!f) { drop.classList.remove("has-file"); photoPrev.setAttribute("href", ""); photoName.textContent = ""; return; }
        if (!/^image\//.test(f.type)) { photoErr.textContent = "Elige una imagen (JPG, PNG o HEIC)."; photo.value = ""; return; }
        if (f.size > 20 * 1024 * 1024) { photoErr.textContent = "La foto pesa más de 20 MB. Prueba con otra."; photo.value = ""; return; }
        drop.classList.add("has-file"); photoName.textContent = f.name;
        const r = new FileReader(); r.onload = () => photoPrev.setAttribute("href", r.result); r.readAsDataURL(f);
      });
      $$(".drop").forEach((d) => {
        d.addEventListener("dragover", (e) => { e.preventDefault(); d.classList.add("has-file"); });
        d.addEventListener("dragleave", () => !photo.files.length && d.classList.remove("has-file"));
        d.addEventListener("drop", (e) => { e.preventDefault(); photo.files = e.dataTransfer.files; photo.dispatchEvent(new Event("change")); });
      });
    }

    form.addEventListener("submit", (e) => {
      if (photo && photo.required && !photo.files.length) { e.preventDefault(); photoErr.textContent = "Sube la foto que irá dentro del relicario."; drop.scrollIntoView({ behavior: "smooth", block: "center" }); return; }
      btn.disabled = true; btn.textContent = "Agregando…";
    });
  }
})();
